import * as actionTypes from './actionTypes';
import initialState from 'reducers/initialState';
import * as eventTypes from './eventTypes';

export const documentsReducer = (state = initialState.document.documents, action) => {
  switch (action.type) {
    case actionTypes.LOAD_DOCUMENT_SIGNEES_SUCCEEDED: {
      return {
        ...state,
        documentSignees: {
          ...state.documentSignees,
          [action.id]: {
            loading: false,
            loaded: true
          }
        }
      };
    }

    case actionTypes.SAVE_DOCUMENT_SIGNEES_STARTED: {
      return {
        ...state,
        documentSignees: {
          ...state.documentSignees,
          [action.id]: {
            loading: false,
            loaded: false,
            saving: true
          }
        }
      };
    }

    case actionTypes.SAVE_DOCUMENT_SIGNEES_FINISHED: {
      return {
        ...state,
        documentSignees: {
          ...state.documentSignees,
          [action.id]: {
            loading: false,
            loaded: true,
            saving: false
          }
        }
      };
    }

    case eventTypes.DOCUMENT_SIGNEES_INVALIDATED: {
      const { documentId, siteId, partnerId } = action.event.eventBody;
      const key = `${documentId}-${siteId}`;
      return {
        ...state,
        documentSignees: {
          ...state.documentSignees,
          [key]: { ...state.documentSignees[key], loading: false, loaded: false, saving: false }
        },
        documentPersons: { ...state.documentPersons, [partnerId]: [] }
      };
    }

    case actionTypes.LOAD_DOCUMENT_PERSONS_STARTED: {
      return {
        ...state,
        documentPersons: {
          ...state.documentPersons,
          [action.id]: {
            values: action.payload,
            loading: true,
            loaded: false
          }
        }
      };
    }

    case actionTypes.LOAD_DOCUMENT_PERSONS_SUCCEEDED: {
      return {
        ...state,
        documentPersons: {
          ...state.documentPersons,
          [action.id]: {
            values: action.payload,
            loading: false,
            loaded: true
          }
        }
      };
    }

    case actionTypes.LOAD_DOC_ENTITIES_SUCCEEDED: {
      return {
        ...state,
        documentEntities: {
          ...state.documentEntities,
          [action.id]: {
            values: action.payload,
            loading: false,
            loaded: true
          }
        }
      };
    }

    


    default:
      return state;
  }
};
